// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfigurationTableType_container__3gMtz"};